import { t } from 'i18next';

import { ReactComponent as PollIcon } from 'assets/icons/actionsPage/chart.svg';
import { ReactComponent as TaskIcon } from 'assets/icons/actionsPage/clipboardTickYellow.svg';
import { ReactComponent as EquipmentsIcon } from 'assets/icons/actionsPage/equipments.svg';
import { ReactComponent as PostIcon } from 'assets/icons/actionsPage/gallery.svg';
import { ReactComponent as NotificationIcon } from 'assets/icons/actionsPage/notificationCustom.svg';
import { ReactComponent as EmployeeIcon } from 'assets/icons/actionsPage/profileAdd.svg';
import { ReactComponent as OffboardingIcon } from 'assets/icons/actionsPage/profileRemove.svg';
import AdligoLogo from 'assets/icons/logos/starLogo63.svg';
import { Links } from 'settings';

import { LogoImage } from './styled';

export const CREATE_ACTIONS_CONFIG = (isManager: boolean) => {
  return {
    POST: {
      label: t(isManager ? 'actions.manager.labels.post' : 'actions.employee.labels.post'),
      description: t('actions.manager.descriptions.post'),
      icon: <PostIcon />,
      link: Links.actions.createPost,
    },
    TASK: {
      label: t(isManager ? 'actions.manager.labels.task' : 'actions.employee.labels.task'),
      description: t('actions.manager.descriptions.task'),
      icon: <TaskIcon />,
      link: Links.actions.createTask,
    },
    POLL: {
      label: t(isManager ? 'actions.manager.labels.poll' : 'actions.employee.labels.poll'),
      description: t('actions.manager.descriptions.poll'),
      icon: <PollIcon />,
      link: Links.actions.createPoll,
    },
    ...(isManager && {
      NOTIFICATIONS: {
        label: t('actions.manager.labels.notifications'),
        description: t('actions.manager.descriptions.notifications'),
        icon: <NotificationIcon />,
        link: Links.actions.createNotification,
      },
    }),
  };
};

export const MANAGE_ACTIONS_CONFIG = (isManager: boolean) => {
  return {
    EMPLOYEE: {
      label: t(
        isManager ? 'actions.manager.labels.onboarding' : 'actions.employee.labels.employee',
      ),
      description: t('actions.manager.descriptions.onboarding'),
      icon: <EmployeeIcon />,
      link: Links.actions.employeesInvite,
    },
    ...(isManager && {
      OFFBOARDING: {
        label: t('actions.manager.labels.offboarding'),
        description: t('actions.manager.descriptions.offboarding'),
        icon: <OffboardingIcon />,
        link: Links.actions.offboarding,
      },
    }),
    EQUIPMENTS: {
      label: t('actions.manager.labels.equipments'),
      description: t('actions.manager.descriptions.equipments'),
      icon: <EquipmentsIcon />,
      link: Links.actions.createEquipment,
    },
    ...(isManager && {
      SUBSCRIPTIONS: {
        label: t('actions.manager.labels.subscriptions'),
        description: t('actions.manager.descriptions.subscriptions'),
        icon: <LogoImage src={AdligoLogo} alt="logo" />,
        link: Links.actions.subscriptions,
      },
    }),
  };
};
